import { DeviceMaximumWidth } from './constants/device.maximum.width'

export class Device {
  /**
   * Returns true when the provided size is lesser than or equal to the specified maximum device width.
   * @param width Width to compare.
   * @param deviceSize Device to compare against.
   * @returns
   */
  static isDeviceSize(width: number, deviceSize: DeviceMaximumWidth): boolean {
    return width <= deviceSize
  }

  /**
   * Returns true when the provided width is lesser than or equal to the maximum Mobile width.
   * @param width Width to compare. If not provided, the width will be retrieved from the window.innerWidth property.
   * @remarks If accessing the window.innerWidth property generates an exception, false will be returned.
   * @returns
   */
  static isMobile(width: number | null = null): boolean {
    // Try catch due to innstances of the window object not being present
    // TODO: Figure out how to handle this when we enable server side rendering.
    if (!width) {
      if (!window) return false
      width = window.innerWidth
    }
    return Device.isDeviceSize(width, DeviceMaximumWidth.Mobile)
  }
}
